import { render, staticRenderFns } from "./cjDetail.vue?vue&type=template&id=ef7228b0&"
import script from "./cjDetail.vue?vue&type=script&lang=ts&"
export * from "./cjDetail.vue?vue&type=script&lang=ts&"
import style0 from "./cjDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports